module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/cards/cards.component.scss
// module id = ./src/app/features/cards/cards.component.scss
// module chunks = main